export const parseSeparatedString = (value: string | null | undefined): string[] =>
  (value ?? '')
    .split(/[,;]/)
    .map((item) => item.trim())
    .filter(Boolean)
